import React from 'react';

const Policy = () => {
  return (
    <div id='policy'>
      <h3>policy</h3>
    </div>
  );
}

export default Policy;
